import { useEffect, useRef, useState } from 'react';

export const useContainerWidth = () => {
	const ref = useRef<HTMLSpanElement>(null);
	const [width, setWidth] = useState<number>(Infinity);

	useEffect(() => {
		const el = ref.current;
		if (!el) return;

		const observer = new ResizeObserver(([entry]) => {
			setWidth(entry.contentRect.width);
		});
		observer.observe(el);
		return () => observer.disconnect();
	}, []);

	return { ref, width };
};
